const navigationTags = {
  relatedTags: null,
  activeLabel: null,
  init() {
    navigationTags.dom();
  },
  dom() {
    navigationTags.relatedTags = document.querySelectorAll(
      '.navigation-tags--with-underline .navigation-tags__list .navigation-tags__list-item'
    );
    if (navigationTags.relatedTags.length > 0) {
      const srElement = document.querySelector('.sr-only');
      navigationTags.activeLabel = srElement || null;
      navigationTags.bindEvents();
    }
  },
  bindEvents() {
    navigationTags.relatedTags.forEach((el) => {
      el.addEventListener('click', function () {
        const parent = el.parentNode;
        const active = parent.querySelector(
          '.navigation-tags__list-item--active'
        );

        if (active !== null) {
          active.classList.removeModifier('active');
          const srLabel = active.querySelector('.sr-only');
          srLabel.remove();
        }
        this.classList.addModifier('active');
        if (navigationTags.activeLabel) {
          this.querySelector('a').appendChild(navigationTags.activeLabel);
        }
      });
    });
  },
};

export default navigationTags;
